import { createContext, useContext } from "react";
import type { CalendarEventType } from "../../../../../types/calendar";
import type { EventFlag } from "../../components/Views/EventBlock";

/**
 * The calendar's flag lookup (index `flagsForEvent`: calendarFlags + the
 * salon's badge toggles) for mobile grid blocks, so the day and week grids
 * don't thread it through every layer. Absent → no chips.
 */
export const MobileFlagsContext = createContext<
  ((event: CalendarEventType) => EventFlag[]) | undefined
>(undefined);

export const useMobileFlagsFor = () => useContext(MobileFlagsContext);
